import React from 'react';
import { Linkedin, User, CheckCircle } from 'lucide-react';

const approachPoints = [
  'Clear communication',
  'Respect for your team',
  'Transparent assumptions',
  'Practical deal structures',
];

const AboutSection = () => {
  return (
    <section 
      id="about" 
      className="py-16 px-6 bg-[#1e3a5f] relative overflow-hidden"
      data-testid="about-section"
    >
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-white/[0.03] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-white mb-8 tracking-tight">
          Who We Are
        </h2>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            <p className="text-white/90 leading-relaxed">
              A principal-led acquisition group focused on acquiring and operating one UK mechanical services business for long-term ownership.
            </p>
            <p className="text-white/75 text-sm leading-relaxed">
              You deal directly with the decision-maker. We are not private equity — our objective is to acquire a strong business and operate it responsibly.
            </p>
            <p className="text-white/75 text-sm leading-relaxed">
              We work with experienced funding partners and lenders to structure transactions efficiently. We work alongside experienced legal, financial and funding advisers to ensure a professional transaction process.
            </p>

            <div className="pt-6 border-t border-white/20 flex items-center gap-4 flex-wrap">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
                <User className="w-6 h-6 text-white/70" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Amogh Achalkar</p>
                <p className="text-white/50 text-xs">Founder & Principal</p>
              </div>
              <a 
                href="https://www.linkedin.com/in/amogh-achalkar-4b505721a"
                target="_blank"
                rel="noopener noreferrer"
                className="sm:ml-auto flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-white/80 text-xs font-medium transition-all"
              >
                <Linkedin className="w-3 h-3" />
                LinkedIn
              </a>
            </div>
          </div>

          <div className="bg-white/10 rounded-xl p-5 border border-white/15 h-fit">
            <h3 className="text-white font-semibold mb-4 text-sm">Our Approach</h3>
            <ul className="space-y-2">
              {approachPoints.map((point, index) => (
                <li key={index} className="flex items-center gap-2 text-white/80 text-sm">
                  <CheckCircle className="w-3.5 h-3.5 text-white/50 flex-shrink-0" />
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
